import { changePlan } from "../api";
import { useApiSend } from "@/hooks/useApi";

// Switching plans moves no money: the paid-for term runs to its end and the
// new plan is what the next renewal charges. Nothing to redirect to, so unlike
// useSubscribe this just reports when it is done.
export function useChangePlan() {
	const { mutateAsync, isPending } = useApiSend({
		fn: changePlan,
		invalidateKeys: [["whoami", "subscription-details"]],
	});

	return { changePlan: mutateAsync, isPending };
}
